webpackJsonp([4],{

/***/ 136:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactStatic = __webpack_require__(20);

var _compileMarkdown = __webpack_require__(134);

var _compileMarkdown2 = _interopRequireDefault(_compileMarkdown);

var _components = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var socialLinkStyle = {
  display: 'inline-block',
  whiteSpace: 'nowrap'
};

exports.default = (0, _reactStatic.withRouteData)(function (_ref) {
  var blurb = _ref.blurb,
      posts = _ref.posts,
      image = _ref.image,
      whereToFindMe = _ref.whereToFindMe,
      projects = _ref.projects;
  return _react2.default.createElement(
    _components.Container,
    { maxWidth: 'medium' },
    _react2.default.createElement(
      _reactStatic.Head,
      null,
      _react2.default.createElement(
        'title',
        null,
        'Will Hoag - Home'
      ),
      _react2.default.createElement('meta', { name: 'description', content: 'Website for the developer, entrepreneur, and indiehacker, Will Hoag' })
    ),
    _react2.default.createElement(
      _components.Flex,
      { flexWrap: 'wrap', mb: [5, 0] },
      _react2.default.createElement(
        _components.Box,
        { my: ['7vh', '8vh'], w: [1, 1 / 3] },
        _react2.default.createElement(_components.AvatarImage, { mx: 'auto', src: image, alt: 'profile image' })
      ),
      _react2.default.createElement(
        _components.Flex,
        { w: [1, 2 / 3], alignItems: 'center' },
        _react2.default.createElement(
          _components.Text,
          { textAlign: ['center', 'left'] },
          (0, _compileMarkdown2.default)(blurb).tree,
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              _components.A,
              { style: socialLinkStyle, mx: [3, 0], mt: 2, href: 'https://twitter.com/devhoag', target: '_blank' },
              _react2.default.createElement(_components.Icon, { style: { verticalAlign: 'middle' }, size: 24, role: 'image', name: 'twitter' }),
              ' @devhoag'
            ),
            _react2.default.createElement(
              _components.A,
              { style: socialLinkStyle, mx: 3, mt: 2, href: 'mailto:dev@willhoag.com', target: '_blank' },
              _react2.default.createElement(_components.Icon, { style: { verticalAlign: 'middle' }, size: 24, role: 'image', name: 'mail' }),
              ' dev@willhoag.com'
            )
          )
        )
      )
    ),
    _react2.default.createElement(
      _components.Box,
      { mb: [5] },
      _react2.default.createElement(
        _components.HeadingWithAnchor,
        { is: 'h2', id: 'latest-projects' },
        'Latest Projects'
      ),
      _react2.default.createElement(_components.ProjectList, { list: projects.filter(function (project) {
          return project.featured;
        }) })
    ),
    _react2.default.createElement(
      _components.Box,
      { mb: [5] },
      _react2.default.createElement(
        _components.HeadingWithAnchor,
        { is: 'h2', id: 'recent-writing' },
        'Recent Writing'
      ),
      _react2.default.createElement(_components.PostsList, { posts: posts.slice(0, 3) }),
      _react2.default.createElement(
        _components.Link,
        { to: '/writing' },
        'More...'
      )
    )
  );
});

/***/ })

});


// WEBPACK FOOTER //
// templates/src/containers/Home.45916b2c.js